import "./Style.css";
export default function LoadingSpinner(){
    return <>
        <div className="loading-spinner">
            <div className="spinner"></div>
        </div>
    </>
}